import axios from "axios";
import config from "./config";
import store from "@/store";

const loadQuestions = () => {
  axios
    .get(`${config.API_URL}${config.QUESTIONS}${config.TOKEN}`)
    .then(function(response) {
      // handle success
      store.commit("setAllQuestions", response.data.entries);
      store.commit("setLoadedSettingsProgress", "setAllQuestions");
    })
    .catch(function(error) {
      // handle error
      console.log(error);
    });
};

const loadIntroSettings = async () => {
  axios
    .get(`${config.API_URL}${config.INTRO_SETTINGS}${config.TOKEN}`)
    .then(function(response) {
      // handle success
      store.commit("setIntroSettings", response.data);
      store.commit("setLoadedSettingsProgress", "setIntroSettings");
    })
    .catch(function(error) {
      // handle error
      console.log(error);
    });
};

const loadRegistrationFormSettings = async () => {
  axios
    .get(`${config.API_URL}${config.REGISTRATION_FORM_SETTINGS}${config.TOKEN}`)
    .then(function(response) {
      // handle success
      store.commit("setRegistrationFormSettings", response.data);
      store.commit("setLoadedSettingsProgress", "setRegistrationFormSettings");
    })
    .catch(function(error) {
      // handle error
      console.log(error);
    });
};

const loadCompletionSettings = async () => {
  axios
    .get(`${config.API_URL}${config.COMPLETION_SETTINGS}${config.TOKEN}`)
    .then(function(response) {
      // handle success
      store.commit("setCompletionSettings", response.data);
      store.commit("setLoadedSettingsProgress", "setCompletionSettings");
    })
    .catch(function(error) {
      // handle error
      console.log(error);
    });
};

const loadTestViewSettings = async () => {
  axios
    .get(`${config.API_URL}${config.TEST_VIEW_SETTINGS}${config.TOKEN}`)
    .then(function(response) {
      // handle success
      store.commit("setTestViewSettings", response.data);
      store.commit("setLoadedSettingsProgress", "setTestViewSettings");
    })
    .catch(function(error) {
      // handle error
      console.log(error);
    });
};

const loadResultViewSettings = async () => {
  axios
    .get(`${config.API_URL}${config.RESULT_VIEW_SETTINGS}${config.TOKEN}`)
    .then(function(response) {
      // handle success
      store.commit("setResultViewSettings", response.data);
      store.commit("setLoadedSettingsProgress", "setResultViewSettings");
    })
    .catch(function(error) {
      // handle error
      console.log(error);
    });
};

const loadPrograms = () => {
  axios
    .get(`${config.API_URL}${config.PROGRAMS}${config.TOKEN}`)
    .then(function(response) {
      // handle success
      store.commit("setAllPrograms", response.data.entries);
      store.commit("setLoadedSettingsProgress", "setAllPrograms");
    })
    .catch(function(error) {
      // handle error
      console.log(error);
    });
};

const loadSettings = () => {
  axios
    .get(`${config.API_URL}${config.SETTINGS}${config.TOKEN}`)
    .then(function(response) {
      // handle success
      store.commit("setSettings", response.data);
      store.commit("setLoadedSettingsProgress", "setSettings");
    })
    .catch(function(error) {
      // handle error
      console.log(error);
    });
};

export const loadData = () => {
  loadIntroSettings();
  loadTestViewSettings();
  loadQuestions();
  loadPrograms();
  loadRegistrationFormSettings();
  loadCompletionSettings();
  loadResultViewSettings();
  loadSettings();
};
